import {
    MDBAlert,
    MDBBtn,
    MDBCard,
    MDBCardBody,
    MDBCardText,
    MDBCardTitle,
    MDBRadio,
    MDBSpinner,
    MDBTabs,
    MDBTabsContent,
    MDBTabsItem,
    MDBTabsLink,
    MDBTabsPane
} from 'mdb-react-ui-kit';
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { editCallBlocking, getAllCallBlockList } from "../../apiclients/streamsapi_bridge";
import Body from "../../components/body/BodyPage";
import MainLinks from "../../components/navlinks/MainLinks";
import SaveChanges from "../../components/topviews/saveCancel.js";
import CallBlockingBlackList from "./CallBlockingBlackList.js";
import CallBlockingWhiteList from "./CallBlockingWhiteList.js";
import { useAdminContext } from '../../components/adminstore/Admin-Context.jsx';
import EditWarning from '../../components/header/EditWarning.jsx';
import TabIDConstant from '../../apiclients/TabIDConstant.js';
function SpamAndBlockingLanding() {
    const [selectedRegion, setSelectedRegion] = useState("IN");
    const { t, i18n } = useTranslation();
    const [basicActive, setBasicActive] = useState('tab1');
    const [blockList, setBlockList] = useState([]);
    const [blockBlackList, setBlockBlackList] = useState([])
    const [isloading, setIsloading] = useState(false);
    const [defaultFieldValue, setDefaultFiedlValue] = useState({});
    const [internalError, setInternalError] = useState(false);
    const [reRender, setRerender] = useState(true);
    const navigate = useNavigate();
    const { isEdited, setEdited } = useAdminContext();
    const [targetView, setTargetView] = useState("");
    const [showWarning, setShowWarning] = useState(false);
    const warningToggle = () => setShowWarning(!showWarning);
    const { register, handleSubmit, setValue, getValues, formState: { errors, isDirty }, reset, watch } = useForm({
        defaultValues: {
            call_block: 1,
        }
    });
    const [successMessage, setSuccessMessage] = useState("");
    const [message, setMessage] = useState(false);

    useEffect(() => {
        if (successMessage) {
            setMessage(true);
            setTimeout(() => {
                setMessage(false);
                setSuccessMessage(""); // Clear the success message in the parent component
            }, 5000);
        }
    }, [successMessage]);
    const handleBasicClick = (value) => {
        if (value !== basicActive && isEdited) {
            setTargetView(value);
            setShowWarning(true);
            return;
        }
        setRerender(true);
        if (value === basicActive) {
            return;
        }
        setBasicActive(value);
    };
    useEffect(() => {
        if (reRender) {
            getCallBlockingList();
            setRerender(false);
        }
    }, [reRender]);

    async function getCallBlockingList() {
        try {
            sessionStorage.setItem("current_link", "spamblocking");
            setIsloading(true);
            setInternalError(false);
            let tabId = basicActive === "tab1" ? TabIDConstant.PERMITTED_SUBLINK : TabIDConstant.BLOCKED_SUBLINK;
            const response = await getAllCallBlockList(
                JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                tabId
            );
            const rawData = await response.json();
            if (response.status === 200) {
                reset({
                    call_block: rawData?.call_blocking?.call_block ? parseInt(rawData.call_blocking.call_block) : 1,
                });
                setBlockList(rawData?.call_blocking ?? {});
            } else if (response.status === 500) {
                setInternalError(true);
            } else {
                //navigate("/");
            }

        } catch (e) {
            console.log(`Unable to process the request:${e}`);
            setInternalError(true);
        } finally {
            setIsloading(false);
        }

    }

    // useEffect(() => {
    //     if (Object.keys(defaultFieldValue).length > 0) {
    //         reset(defaultFieldValue);
    //     }

    // }, [defaultFieldValue]);

    function closeSave(e) {
        //navigate("/userlanding");
        reset();
    }

    useEffect(() => {
        setEdited(isDirty);
    }, [isDirty]);

    const handleOk = () => {
        setEdited(false);
        reset();
        setBasicActive(targetView);
        setShowWarning(false);
    };



    const onSubmit = async (data) => {
        if (isDirty) {
            let update = {
                reqid: 54,
                siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                call_block: data.call_block,
            }
            let saverep = await editCallBlocking(update);
            let saverepeMsg = await saverep.json();
            if (saverepeMsg.status && saverepeMsg.status === "success") {
                // This block executes if saverepeMsg.status exists and is "success"
                setSuccessMessage(saverepeMsg.message);
                setRerender(true);

            } else {

            }
        }
    }

    return (
        <React.Fragment>
            <>
                <MainLinks active={2} />
                <Body
                    tablinks={2}
                    entries={50}
                    sublink={9}
                    content={
                        <>
                            <section className="mb-3">
                                <div className="card card-height">
                                    <div className="card-header py-3 px-0">
                                        <h5 className="mb-0 ">
                                            {t("Spam&Blocking")}
                                        </h5>
                                        <h5 className="mb-0 mt-3">
                                            <MDBCard className='p-0 col-md-6 tab-w-70 shadow-none mob-w-100'>
                                                <MDBCardBody className='d-flex justify-content-between align-items-center rounded bg-info bg-opacity-10'>
                                                    <div>
                                                        <MDBCardTitle className='mb-0'>{t("spamSettings")}</MDBCardTitle>
                                                        Users have the option to override this feature in their settings.
                                                    </div>
                                                    <MDBCardText>
                                                        {/* <MDBRadio className='mb-0'
                                                            {...register("call_block")}
                                                            id='inlineRadio1'
                                                            value='2'
                                                            label='Enable'
                                                            inline
                                                            checked={parseInt(getValues("call_block")) == 3}
                                                            onChange={() => setValue("call_block", 3, { shouldDirty: true })}
                                                        />
                                                        <MDBRadio className='mb-0'
                                                            {...register("call_block")}
                                                            id='inlineRadio2'
                                                            value='1'
                                                            label='Disable'
                                                            inline
                                                            checked={parseInt(getValues("call_block")) == 1}
                                                            onChange={() => setValue("call_block", 1, { shouldDirty: true })}
                                                        /> */}

                                                        <div className="phoneselect">
                                                            <label className="switch">
                                                                <input className="form-control" type="checkbox"
                                                                    checked={parseInt(watch("call_block")) === 3}
                                                                    onChange={(e) => { e.preventDefault(); e.stopPropagation(); setValue("call_block", (e.target.checked ? 3 : 1), { shouldDirty: true }) }}
                                                                />
                                                                <span className="slider round"></span>
                                                            </label>
                                                        </div>


                                                    </MDBCardText>
                                                </MDBCardBody>
                                            </MDBCard>
                                        </h5>

                                    </div>
                                    <div className="card-body px-0">
                                        <MDBTabs className='mb-3'>
                                            <MDBTabsItem>
                                                <MDBTabsLink onClick={() => handleBasicClick('tab1')} active={basicActive === 'tab1'}>
                                                    {t('Permitted')}
                                                </MDBTabsLink>
                                            </MDBTabsItem>
                                            <MDBTabsItem>
                                                <MDBTabsLink onClick={() => handleBasicClick('tab2')} active={basicActive === 'tab2'}>
                                                    {t("Blocked")}
                                                </MDBTabsLink>
                                            </MDBTabsItem>
                                        </MDBTabs>

                                        <MDBTabsContent>
                                            <MDBTabsPane open={basicActive === 'tab1'}>
                                                <CallBlockingWhiteList
                                                    blockList={blockList} isActive={basicActive==='tab1'}
                                                />
                                            </MDBTabsPane>
                                            <MDBTabsPane open={basicActive === 'tab2'}>
                                                <CallBlockingBlackList
                                                    blockList={blockList} isActive={basicActive==='tab2'}
                                                />

                                            </MDBTabsPane>
                                            {isDirty && (
                                                <SaveChanges
                                                    onClose={closeSave}
                                                    isdirtyFields={isDirty}
                                                    onSave={(e) => {
                                                        e.preventDefault();
                                                        handleSubmit(onSubmit)();
                                                    }}
                                                />
                                            )}
                                        </MDBTabsContent>
                                    </div>
                                </div>
                            </section>
                        </>
                    }
                />
                {isloading && (
                    <>
                        <div className="loadingclass">
                            <MDBBtn disabled>
                                <MDBSpinner
                                    size="sm"
                                    role="status"
                                    tag="span"
                                    className="me-2"
                                />
                                Loading...
                            </MDBBtn>
                        </div>
                    </>
                )}
                {internalError && (<MDBAlert
                    open
                    className="alert-center"
                    color="danger"
                    autohide
                    position="bottom-right"
                    delay={3000}
                >Internal Server Error</MDBAlert>)}
                {successMessage && (
                    <MDBAlert
                        open
                        className="alert-center"
                        color="success"
                        autohide
                        position="bottom-right"
                        delay={10000}
                    >
                        <i className="fas fa-check-circle me-3"></i>
                        <span className="alert-msg">{successMessage}</span>
                    </MDBAlert>
                )}

                {showWarning && (
                    <EditWarning
                        warningToggle={warningToggle}
                        setShowWarning={setShowWarning}
                        onOk={handleOk}
                    />
                )}
            </>
        </React.Fragment>
    )
}
export default SpamAndBlockingLanding